<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="businessco_companyname" [ttModel]="edit.businessco_companyname" ttReadonly></tt-input>
        <tt-input ttLabel="cargonizer_api_key" [(ttModel)]="edit.cargonizer_api_key" ttRequired></tt-input>
        <tt-input ttLabel="cargonizer_sender_id" [(ttModel)]="edit.cargonizer_sender_id" ttRequired></tt-input>
        <tt-checkbox ttLabel="cargonizer_testmode" [(ttModel)]="edit.cargonizer_testmode"></tt-checkbox>
        <tt-input ttLabel="ean_prefix_dispatch" [(ttModel)]="edit.ean_prefix_dispatch"></tt-input>
        <tt-select ttLabel="cargonizer_case_p2_reportdef_keyno" [(ttModel)]="edit.cargonizer_case_p2_reportdef_keyno" [ttData]="selectListReports" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>

        <div [hidden]="edit.cargonizer_api_key === ''">
            <tt-button ttText="get_cargonizer_agreements" (ttClick)="getTransportAgreements()" [ttSpin]="gettingTransportAgreements" ttIcon="glyphicon glyphicon-cloud-download"></tt-button>
            <tt-button ttText="get_cargonizer_printers" (ttClick)="getCargonizerPrinters()" [ttSpin]="gettingCargonizerPrinters" ttIcon="glyphicon glyphicon-cloud-download"></tt-button>
        </div>
    </tt-card>
</tt-page>
